import { useEffect, useState } from "react";

const U = (id) => `https://images.unsplash.com/${id}?w=160&q=60&auto=format&fit=crop`;

const MENU_PHOTOS = {
  "black-coffee": U("photo-1509042239860-f550ce710b93"),
  americano: U("photo-1522992319-0365e5f11656"),
  "cold-brew": U("photo-1572442388796-11668a67e53d"),
  espresso: U("photo-1510591509098-f4fdc6d0ff04"),
  macchiato: U("photo-1578314675249-a6910f80cc4e"),
  "cafe-latte": U("photo-1541167760496-1628856ab772"),
  "iced-coffee": U("photo-1517959105821-eaf2591984ca"),
  tea: U("photo-1544787219-7f47ccb76574"),
  "regular-decaf": U("photo-1461023058943-07fcbe16d735"),
};
const FALLBACK_PHOTO = U("photo-1512568400610-62da28bc8a13");

const DEFAULT_MENU = [
  { id: "black-coffee", name: "Black Coffee", price: "" },
  { id: "americano", name: "Americano", price: "" },
  { id: "cold-brew", name: "Cold Brew", price: "" },
  { id: "espresso", name: "Espresso", price: "" },
  { id: "macchiato", name: "Macchiato", price: "" },
  { id: "cafe-latte", name: "Café Latte", price: "" },
  { id: "iced-coffee", name: "Iced Coffee", price: "" },
  { id: "tea", name: "Tea", price: "" },
  { id: "regular-decaf", name: "Regular & Decaf Coffee", price: "" },
];

const menuExtras = [
  { id: "syrups", label: "Syrups", items: "Vanilla, Classic Caramel, Hazelnut, Coconut" },
  { id: "sugar-free", label: "Sugar Free", items: "Vanilla, Caramel, Coconut" },
  { id: "milk", label: "Milk", items: "Regular 2% or Whole, Almond or Vanilla, Oat or Vanilla, Soy, Cashew" },
];

const stations = [
  { id: "snes", name: "SNES / Super Nintendo" },
  { id: "sega", name: "Sega Genesis" },
  { id: "saturn", name: "Sega Saturn" },
  { id: "ps", name: "PlayStation 1, 2 & 4" },
  { id: "xbox", name: "Xbox, Xbox 360 & Xbox One" },
  { id: "wii", name: "Nintendo Wii" },
  { id: "switch", name: "Nintendo Switch" },
];

const Card = ({ title, tag, children, testId }) => (
  <div data-testid={testId} className="bg-[#26153F] p-8 rounded-2xl border border-[#3B2760]">
    <div className="flex items-center justify-between pb-6 border-b border-[#3B2760]">
      <h3 className="display-type text-2xl font-bold uppercase">{title}</h3>
      <span className="mono-lbl text-xs text-[#FF2E88] uppercase font-bold">{tag}</span>
    </div>
    <div className="divide-y divide-[#3B2760] mt-4">{children}</div>
  </div>
);

export const MenuArcade = () => {
  const [menuItems, setMenuItems] = useState(DEFAULT_MENU);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/content`)
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data?.menu?.length) setMenuItems(data.menu);
      })
      .catch(() => {});
  }, []);

  return (
  <section id="menu" data-testid="menu-arcade-section" className="py-20 md:py-28 px-6 md:px-12 max-w-6xl mx-auto">
    <div className="grid md:grid-cols-2 gap-12">
      <Card title="Crafted Menu" tag="House Blends" testId="menu-card">
        {menuItems.map((m) => (
          <div key={m.id} data-testid={`menu-${m.id}`} className="py-3 flex justify-between items-center gap-3">
            <div className="flex items-center gap-3">
              <img
                src={MENU_PHOTOS[m.id] || FALLBACK_PHOTO}
                alt={m.name}
                loading="lazy"
                className="w-11 h-11 rounded-lg object-cover border border-[#3B2760]"
              />
              <div>
                <p className="font-bold text-sm">{m.name}</p>
                <div className="flex gap-1 mt-1">
                  {["S", "M", "L"].map((size) => (
                    <span
                      key={size}
                      data-testid={`size-${m.id}-${size.toLowerCase()}`}
                      className="mono-lbl text-[10px] font-bold text-[#A08FB8] border border-[#3B2760] rounded px-1.5 py-0.5"
                    >
                      {size}
                    </span>
                  ))}
                </div>
              </div>
            </div>
            {m.price && <span className="mono-lbl font-bold text-sm text-[#2DE2E6]">{m.price}</span>}
          </div>
        ))}
        {menuExtras.map((x) => (
          <div key={x.id} data-testid={`menu-extra-${x.id}`} className="py-4">
            <p className="mono-lbl text-xs text-[#FF2E88] uppercase font-bold">{x.label}</p>
            <p className="text-xs text-[#A08FB8] mt-1">{x.items}</p>
          </div>
        ))}
      </Card>
      <div id="games">
        <Card title="Station Lineup" tag="Free To Play" testId="stations-card">
          <p data-testid="stations-donation-note" className="py-4 text-sm font-bold text-[#FF2E88]">
            Donations Welcome for Systems and Games
          </p>
          {stations.map((s) => (
            <div key={s.id} data-testid={`station-${s.id}`} className="py-4 flex justify-between items-baseline">
              <p className="font-bold text-sm">{s.name}</p>
            </div>
          ))}
        </Card>
      </div>
    </div>
  </section>
  );
};
